import {createAsyncThunk, createSlice, isAnyOf} from "@reduxjs/toolkit";
import {checkUserStatus} from "../components/Installations/installationsApi";
import axios from "axios";
import {displayNotification} from "./notification";
import {AUTH_FAIL, TWOFA_FAIL} from "../constants/Messages";
import {SELECTED_INSTALLATION} from "../constants/variables";

export const LOCAL_STORAGE_TOKEN = "FLUXER_TOKEN";
export const LOCAL_STORAGE_EXPIRE_AT = "LOCAL_STORAGE_EXPIRE_AT";

export const initialState = {
    isLoginProgress: false,
    isAuthenticated: false,
    checkUserInProgress: true,
    userInfo: null,
    autoRedirect: null,
    using2Fa: false,
    loginPassed: false,
    refreshTokenPending:false
}
const setTokens = (loginResponse) => {
    localStorage.setItem(LOCAL_STORAGE_TOKEN, loginResponse.token)
    localStorage.setItem(LOCAL_STORAGE_EXPIRE_AT, loginResponse.exp);
}

export const getNewToken = createAsyncThunk(
    'login/refreshtoken',
    async (oldToken) => {
        try {
            const result = await axios.get("/refreshtoken", {
                headers: {
                    "Authorization": `Bearer ${oldToken}`
                }
            })
            setTokens(result.data)
            return result.data;
        } catch (err) {
            return null;
        }
    }
)

export const loginUser = createAsyncThunk(
    '/login/login_user',
    async (data, {dispatch}) => {
        try {
            const response = await axios.post("/authenticate", data);
            if (response.data.using2FA) {
                dispatch(set2FAstatus());
            } else {
                setTokens(response.data);
            }
            return response.data;
        } catch (err) {
            console.log(err)
            dispatch(displayNotification({
                notificationStatus: "error",
                message: AUTH_FAIL,
                title: "Prijava na aplikaciju"
            }))
        }
    }
)
export const login2Fa = createAsyncThunk(
    "login2Fa",
    async ({data, token}, {dispatch}) => {
        try {

            const result = await axios.post("/verify", data, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            setTokens(result.data);
            dispatch(authenticateUser());
            return result.data;
        } catch (err) {
            dispatch(displayNotification({
                notificationStatus: "error",
                message: TWOFA_FAIL,
                title: "Prijava na aplikaciju"
            }))
            return Promise.reject();
        }
    }
)
export const checkUser = createAsyncThunk(
    '/login/check_user',
    async () => {
        const response = await checkUserStatus();
        return response.data
    }
)

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        authenticateUser: (state) => {
            state.isAuthenticated = true;
        },
        set2FAstatus: (state, action) => {
            state.using2Fa = true;
        },
        logout: (state) => {
            state.isAuthenticated = false;
            state.using2Fa = false;
            state.loginPassed = false;
            localStorage.removeItem(LOCAL_STORAGE_TOKEN)
            localStorage.removeItem(SELECTED_INSTALLATION)
            localStorage.removeItem(LOCAL_STORAGE_EXPIRE_AT)
        },
        setAutoRedirect: (state, action) => {
            state.autoRedirect = action.payload;
        },
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.isLoginProgress = true;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.isLoginProgress = false;
            })
            .addCase(checkUser.pending, (state, action) => {
                state.checkUserInProgress = true;
            })
            .addCase(checkUser.rejected, (state, action) => {
                state.checkUserInProgress = false;
                state.isAuthenticated = false;
                localStorage.removeItem(LOCAL_STORAGE_TOKEN);
                localStorage.removeItem(LOCAL_STORAGE_EXPIRE_AT);
            })
            .addCase(checkUser.fulfilled, (state, action) => {
                state.checkUserInProgress = false;
                state.isAuthenticated = true;
                state.userInfo = action.payload
            })
            .addCase(getNewToken.pending, (state) => {
                state.refreshTokenPending = true
            })
            .addCase(getNewToken.fulfilled, (state) => {
                state.refreshTokenPending = false
            })
            .addCase(getNewToken.rejected, (state) => {
                state.refreshTokenPending = false
            })
            .addMatcher(isAnyOf(loginUser.fulfilled, login2Fa.fulfilled), (state, action) => {
                state.isLoginProgress = false;
                state.loginPassed = true;
                state.userInfo = action.payload
                state.checkUserInProgress = false
            })
    }
});

export const {logout, setAutoRedirect, setUserInfo, authenticateUser, set2FAstatus} = authSlice.actions;
export default authSlice.reducer;

